import { TermsVersion1 } from "./versions/Terms.v1";

export * from "./TermsContainer";

// IMPORTANT
// Export the latest version of Terms as CurrentTerms
export const CurrentTerms = TermsVersion1;

export { TermsVersion1 };
